<template>
  <Empty icon="b-icon-bricks" header="No item selected" content="Select an item to view or edit it"></Empty>
</template>

<script>
  import Empty from '../components/Empty';

  export default {
    components: { Empty }
  }
</script>